// =====================================================
// BROKER REGISTRATION CONSTANTS
// =====================================================

export const ALL_LANGUAGES = [
  "French",
  "English",
  "Spanish",
  "German",
  "Italian",
  "Portuguese",
  "Russian",
  "Mandarin",
  "Arabic",
  "Japanese",
  "Other",
] as const;

export const ALL_LANGUAGES_FR = [
  "Français",
  "Anglais",
  "Espagnol",
  "Allemand",
  "Italien",
  "Portugais",
  "Russe",
  "Mandarin",
  "Arabe",
  "Japonais",
  "Autre",
] as const;

export const INDUSTRIES = [
  { value: "all", label: "All" },
  { value: "agriculture_food", label: "Agriculture, Agri-Food & Food Industry" },
  { value: "automotive_marine", label: "Automotive & Boat / Marine" },
  { value: "beauty_personal", label: "Beauty & Personal Care" },
  { value: "construction", label: "Building & Construction (incl. Trades & HVAC)" },
  { value: "communication_media", label: "Communication, Media & Public Relations" },
  { value: "education", label: "Education & Children Services" },
  { value: "entertainment_sport", label: "Entertainment, Recreation & Sport" },
  { value: "financial_insurance", label: "Financial Services & Insurance" },
  { value: "healthcare", label: "Health Care, Medical & Life Sciences" },
  { value: "manufacturing", label: "Manufacturing & Industrial Production" },
  { value: "tech_saas", label: "Online & Technology (SaaS, Web Dev, IT Services)" },
  { value: "pet_services", label: "Pet Services" },
  { value: "restaurant_food", label: "Restaurants & Food Service" },
  { value: "retail", label: "Retail (General, Sport, Specialized)" },
  { value: "service_general", label: "Service Businesses (General)" },
  { value: "transportation", label: "Transportation, Trucking & Logistics" },
  { value: "travel_tourism", label: "Travel, Tourism & Hospitality" },
  { value: "wholesale", label: "Wholesale & Distributors" },
] as const;

export const SPECIALIZED_INDUSTRIES = [
  { value: "accounting_tax", label: "Accounting & Tax Firm (CPA, CA)" },
  { value: "legal_firm", label: "Legal Firm (Corporate, IP, Real Estate)" },
  {
    value: "engineering_consulting",
    label: "Engineering & Technical Consulting (Civil, Electrical, Chemical, Aero)",
  },
  { value: "real_estate", label: "Real Estate Services & Property Management" },
  {
    value: "waste_environmental",
    label: "Waste Management, Water Treatment & Environmental",
  },
  { value: "business_intelligence", label: "Business Intelligence & Data Consulting" },
  { value: "recruitment_hr", label: "Recruitment & Human Resources" },
] as const;

export const EXPERTISE_TYPES = [
  { value: "financial_analysis", label: "Financial analysis" },
  { value: "valuation", label: "Business valuation" },
  { value: "legal_due_diligence", label: "Legal due diligence" },
  { value: "market_research", label: "Market research" },
  { value: "negotiation", label: "Negotiation" },
] as const;

export const EXPERIENCE_YEARS_OPTIONS = [
  { value: "0-5", label: "0 to 5 years" },
  { value: "6-10", label: "6 to 10 years" },
  { value: "10+", label: "10+ years" },
] as const;

export const CANADIAN_PROVINCES = [
  { value: "CA_ON", label: "ON" },
  { value: "CA_QC", label: "QC" },
  { value: "CA_AB", label: "AB" },
  { value: "CA_BC", label: "BC" },
  { value: "CA_MB", label: "MB" },
  { value: "CA_SK", label: "SK" },
  { value: "CA_NS", label: "NS" },
  { value: "CA_NB", label: "NB" },
  { value: "CA_PE", label: "PE" },
  { value: "CA_NL", label: "NL" },
  { value: "CA_NT", label: "NT" },
  { value: "CA_YT", label: "YT" },
  { value: "CA_NU", label: "NU" },
] as const;

export const US_STATES = [
  { value: "US_CA", label: "CA" },
  { value: "US_NY", label: "NY" },
  { value: "US_FL", label: "FL" },
  { value: "US_TX", label: "TX" },
  { value: "US_PA", label: "PA" },
  { value: "US_OH", label: "OH" },
  { value: "US_NC", label: "NC" },
  { value: "US_MI", label: "MI" },
] as const;

export const EUROPEAN_COUNTRIES = [
  { value: "EU_FR", label: "France" },
  { value: "EU_UK", label: "United Kingdom" },
  { value: "EU_DE", label: "Germany" },
  { value: "EU_CH", label: "Switzerland" },
  { value: "EU_LU", label: "Luxembourg" },
  { value: "EU_BE", label: "Belgium" },
] as const;

export const COUNTRIES = [
  { value: "CA", label: "Canada" },
  { value: "US", label: "United States" },
  { value: "FR", label: "France" },
  { value: "UK", label: "United Kingdom" },
  { value: "OTHER", label: "Other" },
] as const;

export const TRANSACTION_TYPES = [
  { value: "asset_purchase", label: "Asset Purchase" },
  { value: "share_purchase", label: "Share Purchase" },
  { value: "merger", label: "Merger" },
  { value: "partnership", label: "Partnership / Joint Venture" },
] as const;

export const EVALUATION_PROCESS_OPTIONS = [
  { value: "credit_check", label: "Credit Check" },
  { value: "financial_review", label: "Financial Review" },
  { value: "industry_experience", label: "Industry Experience Review" },
  { value: "interview", label: "In-Person Interview" },
] as const;

export const NDA_ENFORCEMENT_OPTIONS = [
  { value: "strict", label: "Strict - Signed before any info" },
  { value: "moderate", label: "Moderate - After initial interest" },
  { value: "flexible", label: "Flexible - Case by case" },
] as const;

export const COMMUNICATION_STYLE_OPTIONS = [
  { value: "formal", label: "Formal & Professional" },
  { value: "casual", label: "Casual & Approachable" },
  { value: "direct", label: "Direct & Concise" },
] as const;

export const POST_SALE_ROLE_OPTIONS = [
  { value: "transition_support", label: "Transition Support" },
  { value: "ongoing_advisory", label: "Ongoing Advisory (6-12 months)" },
  { value: "none", label: "None - Transaction only" },
] as const;

export const POF_REQUIREMENT_OPTIONS = [
  { value: "cash_down_payment", label: "Cash Down Payment (% of purchase price)" },
  { value: "fixed_liquid_amount", label: "Fixed Liquid Amount (independent of price)" },
  { value: "pre_approval_letter", label: "Lender Pre-Approval Letter" },
  { value: "no_pof_required", label: "No PoF required upfront" },
] as const;

export const CASH_DOWN_PERCENT_OPTIONS = [
  { value: "10", label: "10%" },
  { value: "20", label: "20%" },
  { value: "30", label: "30%" },
  { value: "40", label: "40%+" },
] as const;

export const FIXED_AMOUNT_OPTIONS = [
  { value: "50k", label: "$50k" },
  { value: "100k", label: "$100k" },
  { value: "250k", label: "$250k" },
  { value: "500k", label: "$500k+" },
] as const;

export const FIXED_AMOUNT_MAX_OPTIONS = [
  { value: "100k", label: "$100k" },
  { value: "250k", label: "$250k" },
  { value: "500k", label: "$500k" },
  { value: "1M+", label: "$1M+" },
] as const;

export const POF_DOCUMENT_TYPES = [
  { value: "bank_statement", label: "Bank Statement (3 months)" },
  { value: "bank_letter", label: "Bank Comfort Letter" },
  { value: "investment_statement", label: "Investment Account Statement" },
  { value: "lender_preapproval", label: "Lender Pre-Approval" },
] as const;

export const COMPETING_OFFERS_OPTIONS = [
  { value: "transparent_disclosure", label: "Transparent disclosure to all parties" },
  { value: "blind_bidding", label: "Blind bidding process" },
  { value: "best_and_final", label: "Best and Final offer round" },
  { value: "first_come", label: "First come, first served" },
] as const;

export const DEAL_SIZE_OPTIONS = [
  { value: "under_500k", label: "Under $500k" },
  { value: "500k_1M", label: "$500k - $1M" },
  { value: "1M_2M", label: "$1M - $2M" },
  { value: "2M_5M", label: "$2M - $5M" },
  { value: "5M_10M", label: "$5M - $10M" },
  { value: "10M_25M", label: "$10M - $25M" },
  { value: "25M_50M", label: "$25M - $50M" },
  { value: "50M_plus", label: "$50M+" },
] as const;

export const FEE_STRUCTURE_OPTIONS = [
  { value: "success_only", label: "Success Fee Only" },
  { value: "retainer_plus_success", label: "Retainer + Success Fee" },
  { value: "hourly", label: "Hourly Rate" },
  { value: "flat_fee", label: "Flat Fee" },
] as const;

export const TOTAL_STEPS = 5;

export const STEP_NAMES = ["Profile", "Expertise", "Model", "Method", "Compliance"] as const;
